import React, { useState } from "react";

import { Button, Flex, Icon, Modal, Tooltip, Typography } from "components";

type ResetToGlobalButtonProps = {
  onResetToGlobal: () => Promise<void>;
  isDraftVersion: boolean;
  selectedCountry: PracticeManagement.CountryCode;
  canEdit: boolean;
  className?: string;
};

export const ResetToGlobalButton = ({ onResetToGlobal, isDraftVersion, selectedCountry, canEdit, className }: ResetToGlobalButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleOk = async () => {
    try {
      await onResetToGlobal();
      setOpen(false);
    } catch {
      // error message handled by mutation's onError
    }
  };

  return (
    <>
      <Button type="secondary" disabled={!isDraftVersion || selectedCountry === "global" || !canEdit} onClick={() => setOpen(true)} className={className}>
        <Flex align="center" gap={4}>
          Reset to global
          <Tooltip
            title={`Replaces this table's ${selectedCountry} values with the current global values. You stay on ${selectedCountry}, but its values now match global. Entries that exist only for ${selectedCountry} are removed.`}
          >
            <span>
              <Icon iconName="tabler/info-circle" size="s" dataTestId="pms-reset-to-global-info" />
            </span>
          </Tooltip>
        </Flex>
      </Button>
      <Modal
        title="Reset to global"
        content={
          <Flex vertical gap={16}>
            <Typography variant="paragraph-m">
              This will overwrite the {selectedCountry} draft with the current global draft values. Existing entries are replaced, and any entries that only
              exist for {selectedCountry} are removed.
            </Typography>
            <Typography variant="paragraph-m" bold>
              Warning: This may affect other users work!
            </Typography>
          </Flex>
        }
        showModal={open}
        okText="Reset"
        okButtonProps={{ danger: true }}
        onOk={handleOk}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};
